import { useMemo } from 'react';
import qrcode from '../../vendor/qrcodeGenerator';

/** L'adresse que le téléphone ouvre : la page publique de scan, le jeton
 *  dans le FRAGMENT (jamais envoyé au serveur, jamais dans ses journaux). */
export const adresseScan = (origine, sessionId, jeton) => `${origine}/scan/${sessionId}#${jeton}`;

/** Le SVG du QR, en chaîne. Niveau de correction M, marge de 4 cases (la
 *  zone calme que les lecteurs exigent), taille libre : le SVG porte un
 *  viewBox, c'est le conteneur qui décide. */
export const svgQr = (texte) => {
    const qr = qrcode(0, 'M');
    qr.addData(texte);
    qr.make();
    return qr.createSvgTag({ cellSize: 4, margin: 4, scalable: true });
};

/**
 * Le QR projeté (chantier jeton, 2026-09-04) : dessiné ICI, par le
 * navigateur, avec le générateur vendorisé (aucun paquet, aucun serveur).
 * Sous le QR, le même lien cliquable : le professeur sans téléphone l'ouvre
 * sur cet ordinateur, même page, même cookie, mêmes règles.
 */
const QrScan = ({ sessionId, jeton, taille = 240 }) => {
    const adresse = adresseScan(window.location.origin, sessionId, jeton);
    const svg = useMemo(() => svgQr(adresse), [adresse]);
    return (
        <div className="flex flex-col items-center gap-2" data-testid="qr-scan">
            {/* Sortie du générateur, déterministe, sans donnée utilisateur : le
                jeton est en base64 URL et l'adresse est la nôtre. */}
            <div
                className="rounded-2xl overflow-hidden bg-white [&_svg]:block [&_svg]:w-full [&_svg]:h-auto"
                style={{ width: taille }}
                dangerouslySetInnerHTML={{ __html: svg }}
            />
            <a
                href={adresse}
                target="_blank"
                rel="noopener noreferrer"
                className="text-white/45 hover:text-white/80 underline underline-offset-4 transition text-sm"
            >
                Pas de téléphone ? Ouvrir ce lien ici
            </a>
        </div>
    );
};

export default QrScan;
